import {
  buildBusinessContactLinks,
  type BusinessContactSettings,
} from "./business-contact";
import { Icon, type IconName } from "./homepage-icons";

// Separate from TRUST_BAR_ITEMS: the header still uses its existing messages.
const SERVICE_BENEFITS: {
  icon: IconName;
  title: string;
  description: string;
}[] = [
  {
    icon: "custom",
    title: "בדיוק במידה שלכם",
    description: "מידות, כמויות ועיצוב אישי",
  },
  {
    icon: "quality",
    title: "איכות שרואים",
    description: "חומרים והדפסה מוקפדים",
  },
  { icon: "service", title: "שירות אישי", description: "עוזרים משלב הרעיון" },
];

export function TrustBar({
  businessSettings,
}: {
  businessSettings: BusinessContactSettings;
}) {
  const { whatsappHref } = buildBusinessContactLinks(businessSettings);
  return (
    <section
      className="hp-trust-bar hp-trust-bar--coloured"
      aria-label="יתרונות שירות"
    >
      <ul role="list">
        {SERVICE_BENEFITS.map((item) => (
          <li key={item.icon}>
            <Icon name={item.icon} size={42} />
            <span className="hp-trust-copy">
              <strong>{item.title}</strong> <span>{item.description}</span>
            </span>
          </li>
        ))}
        <li>
          {whatsappHref ? (
            <a
              className="hp-trust-whatsapp"
              href={whatsappHref}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Icon name="whatsapp" size={46} />
              <span className="hp-trust-copy">
                <strong>הזמנה בוואטסאפ</strong> <span>מהיר, נוח ואישי</span>
              </span>
            </a>
          ) : (
            <>
              <Icon name="design" size={42} />
              <span className="hp-trust-copy">
                <strong>שירות גרפי מקצועי</strong>{" "}
                <span>עיצוב שמותאם להזמנה שלכם</span>
              </span>
            </>
          )}
        </li>
      </ul>
    </section>
  );
}


